export default "__VITE_ASSET__e6333bc7__"